import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { newCentroCostoSchema } from '@/shared';
import {
  useCreateCentrosCostos,
  useUpdateCentrosCostos,
} from '@/shared/actions/erp/administration';
import {
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { CENTROCOSTO } from '@/shared/interfaces';

const returnUrlCentro = '/parametrizacion/centro-costo';

export interface SaveCentroCostoInterface {
  titlePage: string;
  editCentroCosto?: CENTROCOSTO;
}

type SaveFormData = {
  //codigo: string;
  nombre: string;
  estado: boolean;
};

const SaveCentroCosto: React.FC<SaveCentroCostoInterface> = ({
  titlePage,
  editCentroCosto,
}) => {
  const navigate = useNavigate();

  ///* mutations
  const createCentroCostoMutation = useCreateCentrosCostos({ navigate, returnUrl: returnUrlCentro });
  const updateCentroCostoMutation = useUpdateCentrosCostos({ navigate, returnUrl: returnUrlCentro });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newCentroCostoSchema),
    defaultValues: { estado: false },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editCentroCosto?.id_centro_costo) {
      return updateCentroCostoMutation.mutate({
        id: editCentroCosto.id_centro_costo,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createCentroCostoMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editCentroCosto) {
      reset({
        ...editCentroCosto,
      } as any);
    }
  }, [editCentroCosto]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlCentro);
      }}
      onSave={handleSubmit(onSave)}
    >
      
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ''}
      />

      {/* ====== state ====== */}
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveCentroCosto;
